import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { Color } from '../../theme/color'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 32px 0 38px;
`

export const FirstGuideContainer = styled(Link)`
  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    width: 100%;
    margin: 0 16px;
  }
  .notify-icon-box {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background-color: ${Color.gray_1};
  }
  .text-box {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }
`

export const ContentTitle = styled.div`
  display: flex;
  align-items: center;
`

// export const HistoryCardContainer = styled.div`
//   display: grid;
//   grid-template-columns: 1fr 1fr;
//   column-gap: 16px;
//   > div {
//     display: flex;
//     align-items: center;
//     gap: 8px;
//     & > div {
//       display: flex;
//       flex-direction: column;
//       gap: 2px;
//     }
//   }
// `

// export const HistoryContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 16px;
//   margin: 0 16px;
// `

export const ContentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${ContentTitle} {
    padding-left: 16px;
    > a {
      display: flex;
      align-items: center;
    }
  }
`

export const ContentList = styled.div`
  display: flex;
  gap: 8px;
  position: relative;
  > .swiper {
    padding: 16px;
    .swiper-slide {
      width: fit-content;
    }
  }
`
